import { Box, Card, Grid, Stack, Typography } from "@compass/core";
import { ReportOutputFormats, Select } from "components";
import { Survey, SurveyReportViewResource } from "generated/openApi";
import "moment-timezone";

export const SurveyReportReportFilter = (props: {
  selectedSurveyReport: Survey | undefined;
  setSelectedSurveyReport: (value: React.SetStateAction<Survey | undefined>) => void;
  viewResource: SurveyReportViewResource | undefined;
}) => {

  return (
    <Card>
      <Grid container spacing="sm" alignItems="center">
        <Grid item xs={4}>
          <Select
            label="Survey Reports"
            required
            value={props.viewResource?.surveys?.find((x) => x === props.selectedSurveyReport)}
            options={props.viewResource?.surveys}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) => props.setSelectedSurveyReport(value)}
          />
        </Grid>

      </Grid>
    </Card>
  );
};
